import React from 'react'
import { NavLink as BaseNavLink } from 'react-router-dom'

/**
 * React Router v5-compatible NavLink (activeClassName / activeStyle).
 * React Router NavLink with v5-compatible activeClassName / activeStyle.
 */
const NavLink = React.forwardRef(
  ({ activeClassName, activeStyle, className, style, ...props }, ref) => (
    <BaseNavLink
      ref={ref}
      {...props}
      className={({ isActive }) =>
        [typeof className === 'function' ? className({ isActive }) : className, isActive ? activeClassName : null]
          .filter(Boolean)
          .join(' ')
      }
      style={({ isActive }) => ({
        ...(typeof style === 'function' ? style({ isActive }) : style),
        ...(isActive ? activeStyle : null),
      })}
    />
  )
)

NavLink.displayName = 'NavLink'

export default NavLink
